import React, { useEffect, useState } from 'react';
import {
  Collapse, Input, Col, Row, Button, Menu,
} from 'antd';
import {
  BrowserRouter as Router, Route, NavLink, Link, Switch, useHistory,
} from 'react-router-dom';
import { Translation } from 'react-i18next';
import { PREFIX_FRONT_URL } from '../../../consts';

const MENUS = [window.c.routes.FAQS,
  window.c.routes.FAQS_1,
  window.c.routes.FAQS_2,
  window.c.routes.FAQS_3,
  window.c.routes.FAQS_4,
  window.c.routes.FAQS_5,
  window.c.routes.FAQS_6,
];

function QuestionAnswer() {
  const history = useHistory();
  const [color, setColor] = useState('');

  // function getKeyComponent(location) {
  //     console.log(location)
  //     for (let menu of MENUS) {
  //         if (location.pathname.endsWith(menu)) {
  //             return menu;
  //         }
  //     }
  //     return window.c.routes.FAQS;
  // }
  useEffect(() => {
		    setColor(history.location.pathname);
  }, []);

  history.listen((location, action) => {
    setColor(location.pathname);
  });

  return (
    <Translation>
      {(t) => (
        <Menu
        // selectedKeys={selectKeys}
          mode="inline"
          style={{ fontSize: '24px', fontWeight: 700 }}
        >
          <Menu.Item
            key={`${window.c.routes.FAQS_1}`}
            className={color === `/${window.c.routes.FAQS_1}` ? 'abc' : ''}
            onClick={() => history.push(`${PREFIX_FRONT_URL}/${window.c.routes.FAQS_1}`)}
            title={t('ans_title.text_1')}
          >
            <span>1</span>
            {t('ans_title.text_1')}
          </Menu.Item>
          <Menu.Item
            key={`${window.c.routes.FAQS_2}`}
            className={color === `/${window.c.routes.FAQS_2}` ? 'abc' : ''}
            onClick={() => history.push(`${PREFIX_FRONT_URL}/${window.c.routes.FAQS_2}`)}
            title={t('ans_title.text_2')}
          >
            <span>2</span>
            {t('ans_title.text_2')}
          </Menu.Item>
          <Menu.Item
            key={`${window.c.routes.FAQS_3}`}
            className={color === `/${window.c.routes.FAQS_3}` ? 'abc' : ''}
            onClick={() => history.push(`${PREFIX_FRONT_URL}/${window.c.routes.FAQS_3}`)}
            title={t('ans_title.text_3')}
          >
            <span>3</span>
            {t('ans_title.text_3')}
          </Menu.Item>
          <Menu.Item
            key={`${window.c.routes.FAQS_4}`}
            className={color === `/${window.c.routes.FAQS_4}` ? 'abc' : ''}
            onClick={() => history.push(`${PREFIX_FRONT_URL}/${window.c.routes.FAQS_4}`)}
            title={t('ans_title.text_4')}
          >
            <span>4</span>
            {t('ans_title.text_4')}
          </Menu.Item>
          <Menu.Item
            key={`${window.c.routes.FAQS_5}`}
            className={color === `/${window.c.routes.FAQS_5}` ? 'abc' : ''}
            onClick={() => history.push(`${PREFIX_FRONT_URL}/${window.c.routes.FAQS_5}`)}
            title={t('ans_title.text_5')}
          >
            <span>5</span>
            {t('ans_title.text_5')}
          </Menu.Item>
          <Menu.Item
            key={`${window.c.routes.FAQS_6}`}
            className={color === `/${window.c.routes.FAQS_6}` ? 'abc' : ''}
            onClick={() => history.push(`${PREFIX_FRONT_URL}/${window.c.routes.FAQS_6}`)}
            title={t('ans_title.text_6')}
          >
            <span>6</span>
            {t('ans_title.text_6')}
          </Menu.Item>
        </Menu>
      )}
    </Translation>
  );
}

export default QuestionAnswer;
